import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0ddf17a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "p-d-flex p-justify-between" }
const _hoisted_3 = { class: "p-d-flex" }
const _hoisted_4 = {
  key: 0,
  class: "no-data-found"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "p-mt-6 p-d-flex p-justify-center" }, "no data for this period.", -1))
const _hoisted_6 = [
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Chart = _resolveComponent("Chart")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Button, {
          label: "EXPORT CHART",
          onClick: _ctx.downloadChart,
          class: "continue-button"
        }, null, 8, ["onClick"]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_Calendar, {
            inputId: "start",
            modelValue: _ctx.rangeDates,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.rangeDates) = $event)),
            placeholder: "Select range",
            view: "month",
            selectionMode: "range",
            showButtonBar: "",
            class: "p-ml-2 p-mr-2",
            dateFormat: "mm/yy",
            onDateSelect: _ctx.changeDatesRange
          }, null, 8, ["modelValue", "onDateSelect"]),
          _createVNode(_component_Button, {
            icon: "pi pi-refresh",
            class: "p-button-rounded p-button-secondary p-button-outlined p-ml-2 p-mr-2",
            onClick: _ctx.reloadChart
          }, null, 8, ["onClick"])
        ])
      ]),
      _createVNode(_component_Chart, {
        class: "p-mt-2",
        type: "line",
        ref: "dataChartRef",
        data: _ctx.multiAxisData,
        options: _ctx.multiAxisOptions
      }, null, 8, ["data", "options"]),
      (!_ctx.multiAxisData.datasets?.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
        : _createCommentVNode("", true)
    ])
  ]))
}